module.exports = __webpack_public_path__ + "static/media/addToHomeScreen.cfc42b3e.svg";